import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Tooltip,
  Typography,
} from '@locus-taxy/encore-mui';
import { MoreVert, Schema as SchemaIcon } from '@locus-taxy/encore-mui/icons';
import { useState } from 'react';
import type { TFunction } from '@locus-taxy/encore-i18n-toolkit';
import { getTestId } from '@locus-taxy/encore-utils';
import { useRouteContext } from '../../hooks/useRouteContext';
import { TestIdAction } from '../../utils/testIdUtils';

interface MoreActionsMenuProps {
  onViewSchema?: () => void;
  t: TFunction;
}

export default function MoreActionsMenu({
  onViewSchema,
  t,
}: Readonly<MoreActionsMenuProps>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { entity, page } = useRouteContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewSchemaClick = () => {
    if (onViewSchema) {
      onViewSchema();
    }
    handleClose();
  };

  const moreOptionsTooltip = t('common.moreOptions', 'More options');

  return (
    <>
      <Tooltip title={moreOptionsTooltip}>
        <IconButton
          onClick={handleClick}
          aria-label={moreOptionsTooltip}
          data-testid={getTestId({
            action: TestIdAction.OPEN,
            object: 'more-actions',
            entity: entity ?? undefined,
            page: page ?? 'details',
          })}
        >
          <MoreVert />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuList dense>
          {onViewSchema && (
            <MenuItem
              onClick={handleViewSchemaClick}
              data-testid={getTestId({
                action: TestIdAction.VIEW_SCHEMA,
                object: 'view-schema',
                entity: entity ?? undefined,
                page: page ?? 'details',
              })}
            >
              <ListItemIcon>
                <SchemaIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="body2">
                {t('gridView.viewSchema')}
              </Typography>
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </>
  );
}
